import React from 'react'
import PropTypes from 'prop-types'
import { getPreferredCreditPlans } from '../../helpers/creditPlanHelper'
import { PAYPAL_PROVIDED } from '../../helpers/FinanceProviderConstants'

import * as Styled from './Price.styles'

class Price extends React.PureComponent {
  render() {
    const { was, now, flashText, asteriskDisabled, ShowPaypalCreditOption, creditPlansV5 } = this.props
    const NOW_PRICE = now.toFixed(2)
    const HAS_FLASH_TEXT = flashText
    const HAS_WAS_PRICE = Number(was) > 0
    const DISPLAY_WAS_PRICE = HAS_WAS_PRICE && HAS_FLASH_TEXT

    const { availableProviders } = creditPlansV5 ? getPreferredCreditPlans(creditPlansV5) : { availableProviders: [] }

    const isPayPalAvailable = availableProviders.includes(PAYPAL_PROVIDED)

    return (
      <ul className='' itemProp='offers' itemScope itemType='https://schema.org/Offer'>
        <meta itemProp='itemCondition' content='https://schema.org/NewCondition' />
        <Styled.Li itemProp='price' content={NOW_PRICE} data-test='product-price-primary'>
          <span itemProp='priceCurrency' content='GBP' />
          {DISPLAY_WAS_PRICE ? (
            <Styled.OfferPriceTitle>&pound;{NOW_PRICE}</Styled.OfferPriceTitle>
          ) : (
            <h2>&pound;{NOW_PRICE}</h2>
          )}
          {DISPLAY_WAS_PRICE && !asteriskDisabled && (
            <Styled.PriceAsterisk data-test='price-asterisk'>*</Styled.PriceAsterisk>
          )}
        </Styled.Li>
        {isPayPalAvailable && ShowPaypalCreditOption ? (
          <>
            {HAS_FLASH_TEXT && (
              <li>
                <Styled.PriceSave data-test='price-save'>{flashText}</Styled.PriceSave>
              </li>
            )}
            {DISPLAY_WAS_PRICE && (
              <li>
                <Styled.PriceWas
                  data-test='price-was'
                  isPayPalAvailable={isPayPalAvailable}
                  ShowPaypalCreditOption={ShowPaypalCreditOption}
                >{`Was £${was.toFixed(2)}`}</Styled.PriceWas>
              </li>
            )}
          </>
        ) : (
          <li>
            {HAS_FLASH_TEXT && <Styled.PriceSave data-test='price-save'>{flashText}</Styled.PriceSave>}
            {DISPLAY_WAS_PRICE && <Styled.PriceWas data-test='price-was'>{`Was £${was.toFixed(2)}`}</Styled.PriceWas>}
          </li>
        )}
      </ul>
    )
  }
}

Price.propTypes = {
  flashText: PropTypes.string,
  was: PropTypes.number,
  now: PropTypes.number,
  asteriskDisabled: PropTypes.bool
}

export default Price
